var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('cms-header',{staticClass:"cms-head",attrs:{"id":"cms-head"}}),_c('div',{staticClass:"main"},[_c('home-carousel')],1),_c('div',{staticClass:"footer",attrs:{"id":"cms-footer"}},[_c('home-choose'),_c('cms-foot')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }